'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _irisPropTypes = require('@spp/iris-prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Text = function Text(_ref) {
    var text = _ref.text,
        stylizr = _ref.stylizr,
        theme = _ref.theme;
    return _react2.default.createElement(
        'p',
        { className: theme.text },
        stylizr(text.value, text.markup)
    );
};

Text.propTypes = {
    text: _irisPropTypes.objects.text.isRequired,
    stylizr: _propTypes2.default.func.isRequired,
    theme: _propTypes2.default.shape({
        text: _propTypes2.default.string
    })
};

Text.defaultProps = {
    appearance: 'normal',
    stylizr: function stylizr(text) {
        return text;
    },
    theme: {}
};

exports.default = Text;
//# sourceMappingURL=Text.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/hyperion-web-components/~/@spp/ui-text/lib/cjs/Text.js
 ** module id = 530
 ** module chunks = 1
 **/